var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAudioScriptEditorUpload = function SvgIconAudioScriptEditorUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.583 14.808h.833v-3.912l1.75 1.75.59-.594-2.757-2.757-2.756 2.757.595.589 1.745-1.745zM5.513 17.5q-.576 0-.961-.385a1.3 1.3 0 0 1-.386-.96V3.844q0-.575.386-.96.386-.384.96-.385h6.57l3.75 3.75v9.904q0 .576-.384.961a1.3 1.3 0 0 1-.962.385zm6.153-10.833V3.333H5.513a.5.5 0 0 0-.354.16.49.49 0 0 0-.16.353v12.308q0 .191.16.353.16.16.353.16h8.975a.5.5 0 0 0 .352-.16.49.49 0 0 0 .16-.354V6.667z"
  })));
};
export default SvgIconAudioScriptEditorUpload;